import {IServicePerformanceState} from '../state'
import {AsyncActionState} from '../../standard-actions/async-action'
import {DEVICE_TYPE_FIXED} from './services'

export const initialState = Object.freeze({
  services: {
    status: AsyncActionState.NotStarted,
    data: {
      hasServiceTypes: [DEVICE_TYPE_FIXED],
      services: [],
      numberOfServices: 0,
      refreshInterval: 300000,
      stateId: '',
      searchTermsCharacterLimit: 0,
      lastPolledTime: '',
      enableIncident: false,
      customerId: '',
    },
  },
  servicesInt: {
    status: AsyncActionState.NotStarted,
    data: {
      services: [],
      originalServices: [],
      originalCompanies: [],
      originalLocations: [],
      originalServiceTypes: [],
      filterInt: {
        services: {
          searchString: '',
          userType: '',
        },
        companies: [],
        locations: [],
        serviceTypes: [],
      },
    },
    autoStatus: AsyncActionState.NotStarted,
  },
  incidentPriority: {},
  incidents: {
    status: AsyncActionState.NotStarted,
    data: {
      incidents: [],
      pagination: {totalCount: 0, pageSize: 0},
      incidentsCounts: {open: 0, closed: 0},
    },
  },
  siteServices: {
    status: AsyncActionState.NotStarted,
    data: {
      siteServices: [],
      numberOfServices: 0,
      refreshInterval: 300000,
      stateId: '',
      searchTermsCharacterLimit: 0,
      lastPolledTime: '',
    },
  },
  timeRanges: {
    status: AsyncActionState.NotStarted,
    data: [],
  },
  serviceFilters: {
    status: AsyncActionState.NotStarted,
    data: {
      status: [],
      location: [],
      serviceType: [],
    },
  },
  sitesMapData: {
    status: AsyncActionState.NotStarted,
    data: {
      sites: [],
      numberOfSites: 0,
      refreshInterval: 300000,
      mapCentroid: {
        lat: '-26.519215',
        lon: '137.66637',
      },
      mapBoundingBox: {
        topLeftCorner: {
          lat: '0',
          lon: '0',
        },
        bottomRightCorner: {
          lat: '-42.428326',
          lon: '14.48938',
        },
        filteredSites: [],
      },
      searchTermsCharacterLimit: 1,
      stateId: '',
      lastPolledTime: '',
    },
  },
  sites: {
    status: AsyncActionState.NotStarted,
    data: {
      sites: [],
      numberOfSites: 0,
      refreshInterval: 300000,
      stateId: '',
      searchTermsCharacterLimit: 0,
      mapBoundingBox: {
        topLeftCorner: {
          lat: '0',
          lon: '0',
        },
        bottomRightCorner: {
          lat: '-42.42',
          lon: '14.48',
        },
      },
      mapCentroid: {
        lat: '0',
        lon: '0',
      },
      lastPolledTime: '',
    },
  },
  serviceDetail: {
    status: AsyncActionState.NotStarted,
    data: {
      serviceId: '',
      serviceType: '',
      deviceType: DEVICE_TYPE_FIXED,
      refreshInterval: 300000,
      address: null,
      fullAddress: null,
      availability: 0,
      utilisation: 0,
      errors: 0,
      enableIncident: false,
      lastPolledTime: '',
    },
  },
  serviceDetailInt: {
    status: AsyncActionState.NotStarted,
    data: {
      accountName: '',
      accountId: '',
      service: {
        serviceId: '',
      },
    },
  },
  serviceDetailIntBySelectedCidn: {
    status: AsyncActionState.NotStarted,
    data: {
      accountName: '',
      accountId: '',
      service: {
        serviceId: '',
      },
    },
  },
  serviceDetailGraph: {
    status: AsyncActionState.NotStarted,
    data: {
      refreshInterval: 300000,
    },
  },
  sitesSummary: {
    status: AsyncActionState.NotStarted,
    data: {
      numberOfSites: 0,
      numberOfOptimals: 0,
      numberOfIssues: 0,
      optimalAvailability: 0,
      issuesAvailability: 0,
      degradedAvailability: 0,
      noDataAvailability: 0,
      refreshInterval: 300000,
    },
  },
  servicesSummary: {
    status: AsyncActionState.NotStarted,
    data: {
      numberOfServices: 0,
      numberOfOptimals: 0,
      numberOfIssues: 0,
      optimalAvailability: 0,
      issuesAvailability: 0,
      numberOfPlannedMaintenanceServices: 0,
    },
  },
  ipServicesInt: {
    status: AsyncActionState.NotStarted,
    data: [],
  },
  servicesListFilterInt: {
    status: AsyncActionState.NotStarted,
    data: {
      services: [],
      filteredSites: [],
      adaptiveNetworkCountries: [],
      adaptiveNetworkServiceTypes: [],
    },
  },

  deletePrefixServicesInt: {
    status: AsyncActionState.NotStarted,
    data: {},
  },
  exportNetworkPrefixListIntStatus: {
    status: AsyncActionState.NotStarted,
  },
  submitPrefixServicesInt: {
    status: AsyncActionState.NotStarted,
    data: {},
  },
  putReference: {
    status: AsyncActionState.NotStarted,
  },
  putServiceReference: {
    status: AsyncActionState.NotStarted,
  },
  plannedMaintenaceSummary: {
    status: AsyncActionState.NotStarted,
    data: {
      numberOfLocations: 0,
    },
  },
  downloadStatusInt: {
    status: AsyncActionState.NotStarted,
  },
  putServiceReferenceInt: {
    status: AsyncActionState.NotStarted,
  },
  serviceIdReferenceInt: null,
  getUserDynamic: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  validatePrefixService: {
    status: AsyncActionState.NotStarted,
    data: [],
  },
  companyData: {
    status: AsyncActionState.NotStarted,
    data: {
      data: [],
    },
  },
  networkPerformanceReports: {
    status: AsyncActionState.NotStarted,
    data: {
      data: [],
    },
  },
  nPReportsUrl: {
    status: AsyncActionState.NotStarted,
    data: {
      data: null,
    },
  },
  dnsServicesInt: {
    status: AsyncActionState.NotStarted,
    data: [],
  },
  asSetObject: {
    status: AsyncActionState.NotStarted,
    data: {
      asSet_Object: [],
    },
  },
  deleteDnsServicesInt: {
    status: AsyncActionState.NotStarted,
    data: {
      reverseDNSResponse: null,
      secondaryDNSResponse: null,
      primaryDNSResponse: null,
    },
    code: null,
  },
  exportReverseDnsIntStatus: {
    status: AsyncActionState.NotStarted,
  },
  submitDnsServicesInt: {
    status: AsyncActionState.NotStarted,
    data: {},
  },
  serviceTypesInt: {
    status: AsyncActionState.NotStarted,
    data: {
      serviceTypes: [],
    },
  },
}) as Readonly<IServicePerformanceState>
